module.exports = [
  "C",
  "C++",
  "JAVA",
  "Python",
  "Go",
  "Javascript(ES6+)",
  "Flutter",
  "Android",
  "Git",
  "Firebase",
  "HTML",
  "CSS",
  "ReactJS",
  "Redux",
  "NodeJS",
  "ExpressJS",
  "MongoDB",
  "PHP",
  "Laravel",
];
